import React, { Component } from 'react'

export class Card extends Component {
  render() {
    const addColor = {
      color: this.props.addColor
    }
    return (
      <div className="card">
        <p className="card-title"><span style={addColor}>{this.props.name} Score - </span>
          {/* <span className="slash">/</span> */}
          <span style={addColor}>{this.props.howMuch}%</span><br />
          <span className="normalDev"> (vs 70% - normal  development)</span>
        </p>
        <p className="card-description">{this.props.description}</p>
      </div>
    )
  }
}

export default Card